/**
 * lucide-react v0.233.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const Scissors = createLucideIcon("Scissors", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["line", { x1: "20", x2: "8.12", y1: "4", y2: "15.88", key: "3m06te" }],
  ["line", { x1: "14.47", x2: "20", y1: "14.48", y2: "20", key: "117692" }],
  ["line", { x1: "8.12", x2: "12", y1: "8.12", y2: "12", key: "1oaf4y" }]
]);

export { Scissors as default };
//# sourceMappingURL=scissors.js.map
